import { checkKey } from "helpers/auth";

// export const convertQuoteToPolicy = async ( payload) => {
// 	let response = {};
// 	const endpoint = `/convertQuoteToPolicy`;

// 	response = await checkKey({ endpoint, payload, token });
// 	return response;
// };


// export const convertWebQuoteToQuotation = async ( payload) => {
// 	let response = {};
// 	const endpoint = `/convertWebQuoteToQuotation`;

// 	response = await checkKey({ endpoint, payload, token });
// 	return response;
// };

export const convertQuoteToPolicy = async (   quote_id, quote_number) => {
	let response = {};
	const endpoint = `convertQuoteToPolicy`;
	const payload = {
		params: {
            quote_id:  quote_id,
			quote_number: quote_number,            
		},
	};
	const reqType = "get";

	response = await checkKey({ endpoint, payload,  reqType });

	return response;
};

export const convertWebQuoteToQuotation = async (  quote_number) => {
	let response = {};
	const endpoint = `convertWebQuoteToQuotation`;
	const payload = {
		params: {
			quote_number: quote_number,
		},
	};
	const reqType = "get";

	response = await checkKey({ endpoint, payload,  reqType });

	return response;
};



export const submitQuotation = async ( payload) => {
	let response = {};
	const endpoint = `/submitQuotation`;

	response = await checkKey({ endpoint, payload});
	return response;
};

export const  quotationMotorDirectSubmit = async ( payload) => {
	let response = {};
	const endpoint = `/quotationMotorDirectSubmit`;

	response = await checkKey({ endpoint, payload});
	return response;
};